<template>
  <div class="diet-info-container">
    <div class="patient-info-content">
      <h3 class="sidebar-title">Pauta {{dietData.total_requirements ? "(" + dietData.total_requirements + " kcal)" : ""}}</h3>
      <div v-if="dietData">
        <h6 class="patient-info-title"> Macronutrientes </h6>
        <div class="row ml-1">
          <p class="col-6 patient-info-data">
            <span>- Proteína: </span>
          </p>
          <p class="col-6 patient-info-data">
            <span v-if="dietData.total_protein_grams">{{dietData.total_protein_grams}} gr</span>
            <span v-else>--</span>
          </p>
          <p class="col-6 patient-info-data">
            <span>- Lípidos:</span>
          </p>
          <p class="col-6 patient-info-data">
            <span v-if="dietData.total_lipid_grams">{{dietData.total_lipid_grams}} gr</span>
            <span v-else>--</span>
          </p>
          <p class="col-6 patient-info-data">
            <span>- CHO: </span>
          </p>
          <p class="col-6 patient-info-data">
            <span v-if="dietData.total_cho_grams">{{dietData.total_cho_grams}} gr</span>
            <span v-else>--</span>
          </p>
        </div>
        <h6 class="patient-info-title"> Porciones </h6>
        <p class="patient-info-data ml-3" v-for="(portion, index) in totalPortions" :key="index">
          <span :style="portion.hasError ? {color: 'red'} : {}">
            - {{portion.quantity}} / {{portion.goal}} {{portion.food_group.name}}
          </span>
        </p>
        <h6 class="patient-info-title"> Resumen comidas </h6>
        <p class="patient-info-data ml-3 mt-1" v-for="(meal, index) in meals" :key="index">
          <span>
            {{meal.name}} ({{getTime(meal.start_time)}}{{meal.end_time ? " - " + getTime(meal.end_time) : ""}})
          </span>
          <ul v-if="meal.portions" class="dashed">
            <li v-for="(portion, index) in meal.portions"
              :key="index"
            >{{portion.quantity}} {{portion.food_group.name}}</li>
          </ul>
        </p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "DietInfo",
  props: {
    dietData: {
      type: Object,
      default: function(){
        return {
          portions: [],
          meals: []
        };
      },
    },
  },
  data: function() {
    return {
      portions: this.dietData.portions,
      meals: this.dietData.meals
    };
  },
  computed: {
    totalPortions: function () {
      let total = {}
      for (const portion of this.portions) {
        total[portion.food_group.id] = {
          quantity: 0,
          goal: Number(portion.quantity),
          hasError: false,
          food_group: portion.food_group
        }
      }
      for (const meal of this.meals) {
        for (const portion of meal.portions) {
          if (total.hasOwnProperty(portion.food_group.id)) {
            total[portion.food_group.id].quantity += Number(portion.quantity)
          } else {
            total[portion.food_group.id] = {
              quantity: Number(portion.quantity),
              goal: 0,
              hasError: false,
              food_group: portion.food_group
            }
          }
          
        }
      }
      for (const food in total) {
        if (total[food].quantity != total[food].goal) {
          total[food].hasError = true       
        }
      }
      return total
    },
    hasError: function () {
      let portions = this.totalPortions
      let error = false
      for (const key in portions) {
        error = error || portions[key].hasError
      }
      return error
    }
  },
  methods: {
    getTime(time) {
      if (this.$moment(time, ["HH:mm:ss", "HH:mm"]).isValid()) {
        return this.$moment(time, ["HH:mm:ss", "HH:mm"]).format("HH:mm")
      }
      return " "
    },
    getError() {
      return this.hasError
    }
  },
  watch: {
    'dietData.portions': function (newValue) {
      this.portions = newValue
    },
    'dietData.meals': function (newValue) {
      this.meals = newValue
    },
    hasError: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit("error-changed", newValue)
      }
    }
  },
};
</script>

<style scoped lang="scss">
.diet-info-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.patient-info-content {
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 100%;

  & button {
    margin-top: 1rem;
  }
}

.patient-info-button-container {
  padding-top: 1rem;
}

.patient-info-title {
  margin-top: 1.25rem;
  margin-bottom: 0.6rem;
  font-size: $font-size-sm;
}

.patient-info-data {
  padding-top: 0.25rem;
  padding-bottom: 0.1rem;
  margin: 0;
  line-height: 1.2;
  font-size: $font-size-sm;
}

.patient-info-separator {
  margin: 2rem 0;
  height: 0;
  background-color: $gray-300;
}
ul {
  margin: 0;
}
ul.dashed {
  list-style-type: none;
}
ul.dashed > li {
  text-indent: -10px;
}
ul.dashed > li:before {
  content: "- ";
  text-indent: -10px;
}
</style>